import React from 'react';
import { Flex, Text, Icon } from 'roo-ui/components';
import PropTypes from 'prop-types';

const CheckInInfo = ({ property, ...rest }) => (
  <Flex {...rest}>
    <Flex flexDirection="column">
      <Text ml={1} mb={1}>
        Check-in time
      </Text>
      <Flex>
        <Icon name="accessTime" size={20} mr={1} />
        From {property.checkInAfter}
      </Flex>
    </Flex>
    <Flex flexDirection="column" ml={9}>
      <Text ml={1} mb={1}>
        Check-out time
      </Text>
      <Flex>
        <Icon name="accessTime" size={20} mr={1} />
        Until {property.checkOutBefore}
      </Flex>
    </Flex>
  </Flex>
);

CheckInInfo.propTypes = {
  property: PropTypes.object.isRequired,
};

export default CheckInInfo;
